<template>
  <b-field grouped :style="{ flexDirection }">
    <b-field
      :expanded="expanded"
      :style="{
        marginRight: flexDirection === 'row' ? '0.75rem' : '0',
        marginBottom: flexDirection === 'row' ? '0.75rem' : '0'
      }"
    >
      <b-datepicker
        v-model="date"
        :placeholder="datePlaceholder"
        :date-formatter="formatDate"
        icon="calendar"
      ></b-datepicker>
    </b-field>
    <b-field v-show="isShowTime" :expanded="expanded">
      <b-timepicker v-model="time" :placeholder="timePlaceholder" icon="clock" editable> </b-timepicker>
    </b-field>
  </b-field>
</template>

<script>
import moment from '@/plugins/moment'
export default {
  name: 'DateTimePicker',
  props: {
    initDate: {
      type: Date,
      default: () => new Date()
    },
    initTime: {
      type: Date,
      default: () => new Date(2018, 0, 1)
    },
    flexDirection: {
      type: String,
      default: 'row'
    },
    datePlaceholder: {
      type: String,
      default: ''
    },
    timePlaceholder: {
      type: String,
      default: ''
    },
    expanded: {
      type: Boolean,
      default: false
    },
    isShowTime: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      // Today - 7 days
      date: this.initDate,
      time: this.initTime
    }
  },
  watch: {
    date: {
      handler: 'updateDateTime',
      immediate: true
    },
    time: {
      handler: 'updateDateTime',
      immediate: true
    }
  },
  methods: {
    formatDate() {
      return moment(this.date).format('DD.MM.YYYY')
    },
    updateDateTime() {
      let date = moment(this.date).format('YYYY-MM-DD')
      let time = moment(this.time).format('HH:mm')
      let dateTime = moment(`${date} ${time}`)
      let dateTimeUnix = moment(dateTime).unix()
      let timestapmp = new Date(dateTime).getTime()
      this.$emit('input', dateTimeUnix)
      this.$emit('input-timestamp', timestapmp)
    }
  }
}
</script>

<style lang="scss">
.datepicker .dropdown .dropdown-menu {
  .datepicker-header .pagination-list .control select {
    padding-right: 2.5em;
  }
  .datepicker-content {
    font-size: 0.9rem;
    height: auto;
  }
}
.timepicker .dropdown .dropdown-menu .control {
  font-size: 0.9rem;
}
</style>
